export default __webpack_public_path__ + "8f7d000a2b25b1f0a43457a8d4004aef.svg";